import React from 'react'

import { Card, Chip, makeAppStyles, Typography } from '@percept/mui'

import { providerLabelMap } from '@percept/constants'

import { ReportProviderV2 } from '@percept/types'


const useStyles = makeAppStyles( theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
    alignSelf: 'end',
    flexGrow: 1,
  },
  title: {
    fontSize: 13,
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    margin: theme.spacing(1, 0),
  },
  metric: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  chip: {
    height: 16,
    padding: 0,
    fontSize: 10,
    marginLeft: theme.spacing(0.75),
    color: theme.palette.text.secondary,
  },
}))


export const PerformanceDetailCardContent = ({
  title,
  children,
  subtitle,
  className,
}: React.PropsWithChildren<{
  title?: React.ReactNode
  subtitle: React.ReactNode
  className?: string
}>) => {
  const classes = useStyles()
  const rootClassName = className ? `${classes.root} ${className}` : classes.root
  return (
    <div className={rootClassName}>
      { title && (
        <Typography variant='h5' className={classes.title}>
          { title }
        </Typography>
      )}
      <div className={classes.content}>
        { children }
      </div>
      <Typography variant='h5' className={classes.metric}>{ subtitle }</Typography>
    </div>
  )
}


export type PerformanceDetailCardProps = React.PropsWithChildren<{
  provider: ReportProviderV2
  segment?: string | null
  metric: React.ReactNode
}>

export const PerformanceDetailCard = ({
  provider,
  segment,
  metric,
  children,
}: PerformanceDetailCardProps) => {
  const classes = useStyles()
  return (
    <Card elevation={3}>
      <PerformanceDetailCardContent
        title={
          <>
            { providerLabelMap[provider] }
            { segment && (
              <Chip
                size='small'
                variant='outlined'
                classes={{root: classes.chip}}
                label={segment} />
            )}
          </>
        }
        subtitle={metric}>
        { children }
      </PerformanceDetailCardContent>
    </Card>
  )
}
